import React from "react";
import ReactMapboxGl, { Marker } from "react-mapbox-gl";
import { MapImg } from "./styled";

interface IMap {
  accessToken: string;
  style: string;
  coordinates: number[];
}

interface Props {
  map: IMap;
}

const MapBox: React.FC<Props> = ({ map }) => {
  const Map = ReactMapboxGl({
    accessToken: map.accessToken,
    minZoom: 10,
    logoPosition: "top-right",
    scrollZoom: false,
  });

  return (
    <Map
      style={map.style}
      containerStyle={{
        height: "100%",
        width: "100%",
      }}
      center={map.coordinates as [number, number]}
    >
      <Marker coordinates={map.coordinates as [number, number]} anchor="top">
        <MapImg src="/images/icons/pin.png" alt="marker icon" />
      </Marker>
    </Map>
  );
};

export default MapBox;
